import request from "./axios";

function create(params) {
  return request({
    method: "post",
    url: `/webinar_enrollments`,
    data: { webinar: params },
  });
}

const WebinarEnrollmentsService = {
  create,
};

export default WebinarEnrollmentsService;
